import pro1 from "../sources/i1.jpg";
import pro3 from "../sources/i3.jpg";
import pro5 from "../sources/i5.jpg";
import pro7 from "../sources/i7.png";
import pro11 from "../sources/i11.png";
import pro13 from "../sources/i20.png";
import pro15 from "../sources/i15.png";
import pro17 from "../sources/i17.png";
import pro18 from "../sources/i18.png";
import pro51 from "../sources/i51.png";
import pro87 from "../sources/i87.png";


import alt1 from "../sources/i2.jpg";
import alt3 from "../sources/i4.jpg";
import alt5 from "../sources/i6.jpg";
import alt7 from "../sources/i8.png";
import alt11 from "../sources/i12.png";
import alt13 from "../sources/i4.jpg";
import alt15 from "../sources/i16.png";
import alt17 from "../sources/i17.png";
import alt18 from "../sources/i19.png";
import alt21 from "../sources/i21.png";
import alt33 from "../sources/i33.png";
import alt51 from "../sources/i22.png";


import hover13 from "../sources/close.png";

const Clothes = [
    // {
    //     id: 1,
    //     imgURL: pro1,
    //     altURL: alt1,
    //     price: 1.00,
    //     name: "Vengeance of the Hood",
    //     description: "I'm a product",
    //     category: "T-Shirts"
    // },
    // {
    //     id: 5,
    //     imgURL: pro5,
    //     altURL: alt5,
    //     price:1.00,
    //     name: "Vengeance of the Hood",
    //     description: "I'm a product",
    //     category: "T-Shirts"
    // },
    {
        id: 13,
        imgURL: pro13,
        altURL: alt21,
        hoveredImgURL: hover13,
        price: 599.00,
        name: "Hood Over Fear",
        color:"Black",
        description: "A3-print (14.1 x 16)",
        category: "T-Shirts"
    },
    // {
    //     id: 3,
    //     imgURL: pro3,
    //     altURL: alt3,
    //     price:2.00,
    //     name: "True Hood Original",
    //     description: "I'm a product",
    //     category: "T-Shirts"
    // },
    // {
    //     id: 15,
    //     imgURL: pro15,
    //     altURL: alt15,
    //     price:1.00,
    //     name: "True Hood Original",
    //     description: "I'm a product",
    //     category: "T-Shirts"
    // },
    // {
    //     id: 11,
    //     imgURL: pro11,
    //     altURL: alt11,
    //     price:1.00,
    //     name: "The Kendrick Lamar Tee",
    //     description: "I'm a product",
    //     category: "T-Shirts"
    // },
    // {
    //     id: 7,
    //     imgURL: pro7,
    //     altURL: alt7,
    //     price:3.00,
    //     name: "The Black Panther Tee",
    //     description: "I'm a product",
    //     category: "T-Shirts"
    // },
    
    {
        id: 17,
        imgURL: pro18,
        altURL: alt21,
        price: 599.00,
        name: "True Hood Culture",
        color:"Black",
        description: "A3-print (14.1 x 16)",
        category: "T-Shirts"
    },
    {
        id: 51,
        imgURL: pro51,
        altURL: alt51,
        price: 499.00,
        name: "The Kendrick Lamar Tee",
        color:"White",
        description: "A3-print (11.5 x 16.5)",
        category: "T-Shirts"
    },
    {
        id: 87,
        imgURL: pro87,
        altURL: alt51,
        price: 499.00,
        name: "The Vacation Tee",
        color:"White",
        description: "A3-print (11.5 x 12.23)",
        category: "T-Shirts"
    }
];

export default Clothes;